import { useState, useEffect, useCallback } from "react";
import {ToastContainer, toast} from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { createSetDataFreshAction } from "../actions/dataActions";
import { getDataFresh } from "../state/selectors";


const doNotSavedNotification = message => {
  if (message) {
    toast.warning(message + "\nWarning: Data not yet saved!", {position: "top-right"});
  }
};

export default function useSafeSave(
  saveFunction,
  lastChange,
  validator,
  conflictCheck
) {
  const [clean, setClean] = useState(true);
  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);

  const makeDirty = () => {
    setClean(false);
  };

  const safeSave = useCallback(() => {
    return new Promise((res, rej) => {
      setClean(true);
      let validation = validator ? validator() : { result: true };
      if (validation.result) {
        conflictCheck().then(result => {
          if (result) {
            saveFunction()
              .then(() => {
                res();
              })
              .catch(err => {
                console.log(err)
                toast.error(err.message, {position: "top-right"});
                rej();
                setClean(false);
              });
          } else {
            toast.error("It looks like the data has been edited elsewhere - fetching the latest update! ", {position: "top-right"});
            dispatch(createSetDataFreshAction(dataFresh + 1));
            rej();
          }
        }).catch(err => {
          toast.error("An error occurred!", {position: "top-right"});
        });
      } else {
        let partSuppliers = validation.missingPartSuppliers.length
          ? `\n The following parts are missing suppliers: ${validation.missingPartSuppliers.join(
              ", "
            )}`
          : ``;

        let invalidWorkItems = validation.invalidWorkTypes.length
            ? `\nThe following work items are missing work types: ${validation.invalidWorkTypes.join(", ")}` : '';


        let message = `The following fields are missing: ${validation.missing.join(
          ", "
        )} ${partSuppliers} ${invalidWorkItems}`;

        doNotSavedNotification(message);
        rej("Validation failed!");
      }
    });
  }, [validator, saveFunction, conflictCheck, dataFresh, dispatch]);

  useEffect(() => {
    if (!clean) {
      doNotSavedNotification();
    }
  }, [clean]);

  return [makeDirty, safeSave];
}
